import { readRefusal } from '@/api/api';

/** True when the server refused the words of a reply: too long, or nothing visible once trimmed. */
export const isCommentReplyContentRefusal = (error: unknown): boolean =>
    readRefusal(error)?.status === 400;
